import { apiFetch } from '@/lib/api'
import { useQuery } from '@tanstack/react-query'

export interface RegistryVersions {
  webApp: string[]
  openclaw: string[]
  pocketbase: string[]
  caddy: string[]
  /** Single-element array holding `settings.default_n8n_tag`. Empty if unset. */
  n8n: string[]
}

export function useRegistryVersions(enabled = true) {
  return useQuery<RegistryVersions>({
    queryKey: ['registry_versions'],
    queryFn: async () => {
      const res = await apiFetch('/api/registry/versions')
      if (!res.ok) throw new Error(`Failed to fetch registry versions: ${res.status}`)
      const data = await res.json()
      return {
        webApp: data['dmc-frontend'] ?? data.webApp ?? data.web_app ?? [],
        openclaw: data['dmc-openclaw'] ?? data.openclaw ?? [],
        pocketbase: data['dmc-pocketbase'] ?? data.pocketbase ?? [],
        caddy: data['dmc-caddy'] ?? data.caddy ?? [],
        n8n: data.n8n ?? [],
      }
    },
    enabled,
    staleTime: 0,
    retry: 2,
  })
}
